import Vue from 'vue';
import VueRouter from 'vue-router';

import { authenticationGuard } from '@/authentication-guard';

Vue.use(VueRouter);

const router = new VueRouter({
  routes: [
    {
      path: '/',
      redirect: { name: 'about' },
    },
    {
      path: '/register',
      name: 'registration',
      component: () => import('./views/RegistrationView.vue'),
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('./views/AboutView.vue'),
      beforeEnter: authenticationGuard,
    },
    {
      path: '/assessment/:assessmentId',
      name: 'assessment',
      component: () => import('./views/AssessmentView.vue'),
      beforeEnter: authenticationGuard,
      children: [
        {
          path: 'questions/section/:sectionId',
          name: 'questions-section',
          component: () => import('./views/QuestionsView.vue'),
          beforeEnter: authenticationGuard,
        },
        {
          path: 'threats/section/:sectionId',
          name: 'threats-section',
          component: () => import('./views/ThreatsView.vue'),
          beforeEnter: authenticationGuard,
        },
        {
          path: 'summary',
          name: 'summary',
          component: () => import('./views/SummaryView.vue'),
          beforeEnter: authenticationGuard,
        },
      ],
    },
    {
      path: '/report/:assessmentId',
      name: 'report',
      component: () => import('./views/ReportView.vue'),
    },
  ],
});

export default router;
